<template>
  <div class="index" v-title data-title="衡水滏阳中学">
    <el-row>
      <!-- 头部 -->
      <header-elem></header-elem>
      <!-- 轮播图 -->
      <rotation-elem></rotation-elem>
    </el-row>
    <el-row class="row_css">
      <!-- 校园新闻 -->
      <el-col :span="15" style="padding-right:20px;">
        <div class="boxCss">
          <div class="box_top">
            <div class="box_title">
              <span>校</span>园新闻
            </div>
            <router-link class="box_more" :to="{path:'/leftNavList',query: {fId:1, id:15, name:'今日滏中', secondName:'校园新闻'}}" tag="a">MORE</router-link>
          </div>
          <div class="box_bottom">
            <el-col :span="12" style="padding-right: 20px;">
              <div v-for="(list,index) in xyxwData" :key="index">
                <div v-show="index==0">
                  <router-link tag="a" :to="{path:'/article',query: {id:list.id, fId:1, sId:15, seo_title:list.seo_title}}" :title="list.title" class="article_first_title">
                    <div class="article_first_img">
                      <img :src="list.thumb ? list.thumb : '../../static/img/noImg.png'" alt />
                    </div>
                    <p class="xyxw_title">{{list.title}}</p>
                    <div class="article_first_details">{{list.description}}</div>
                  </router-link>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <ul>
                <li v-for="(list,index) in xyxwData" :key="index">
                  <div v-if="index<11" class="underLine_title">
                    <router-link tag="a" :to="{path:'/article',query: {id:list.id, fId:1, sId:15, seo_title:list.seo_title}}" :title="list.title" class="article_title">{{list.title}}</router-link>
                    <div class="article_time">{{list.updatetime | timesubStr}}</div>
                  </div>
                </li>
              </ul>
            </el-col>
          </div>
        </div>
      </el-col>
      <!-- 公告通知 -->
      <el-col :span="9">
        <div class="boxCss">
          <div class="box_top">
            <div class="box_title">
              <span>公</span>告通知
            </div>
            <router-link class="box_more" :to="{path:'/leftNavList',query: {fId:1, id:16, name:'今日滏中', secondName:'公告通知'}}" tag="a">MORE</router-link>
          </div>
          <div class="box_bottom">
            <ul>
              <li v-for="(list,index) in ggtzData" :key="index">
                <div v-if="index<11" class="underLine_title">
                  <router-link tag="a" :to="{path:'/article',query: {id:list.id, fId:1, sId:16, seo_title:list.seo_title}}" :title="list.title" class="article_title arrow_tip">{{list.title}}</router-link>
                  <div class="article_time">{{list.updatetime | timesubStrYear}}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="row_css zyzx">
      <!-- 教学之窗 -->
      <el-col :span="6">
        <div class="box_top">
          <div class="box_title">
            <span>教</span>学之窗
          </div>
          <router-link class="box_more" :to="{path:'/list',query: {fId:8, id:8, name:'教学之窗'}}" tag="a">MORE</router-link>
        </div>
        <div class="box_bottom">
          <ul>
            <li v-for="(list,index) in jxzcData" :key="index">
              <div v-if="index<8" class="underLine_title">
                <router-link tag="a" :to="{path:'/article',query: {id:list.id, fId:8, seo_title:list.seo_title}}" :title="list.title" class="article_title_one">{{list.title}}</router-link>
              </div>
            </li>
          </ul>
        </div>
      </el-col>
      <!-- 德育之窗 -->
      <el-col :span="6" class="middle_box_right">
        <div class="box_top">
          <div class="box_title">
            <span>德</span>育之窗
          </div>
          <router-link class="box_more" :to="{path:'/list',query: {fId:6, id:6, name:'德育之窗'}}" tag="a">MORE</router-link>
        </div>
        <div class="box_bottom">
          <ul>
            <li v-for="(list,index) in dyzcData" :key="index">
              <div v-if="index<8" class="underLine_title">
                <router-link tag="a" :to="{path:'/article',query: {id:list.id, fId:6, seo_title:list.seo_title}}" :title="list.title" class="article_title_one">{{list.title}}</router-link>
              </div>
            </li>
          </ul>
        </div>
      </el-col>
      <!-- 党建之窗 -->
      <el-col :span="6" class="middle_box_right">
        <div class="box_top">
          <div class="box_title">
            <span>党</span>建之窗
          </div>
          <router-link class="box_more" :to="{path:'/list',query: {fId:7, id:7, name:'党建之窗'}}" tag="a">MORE</router-link>
        </div>
        <div class="box_bottom">
          <ul>
            <li v-for="(list,index) in djzcData" :key="index">
              <div v-if="index<8" class="underLine_title">
                <router-link tag="a" :to="{path:'/article',query: {id:list.id, fId:7, seo_title:list.seo_title}}" :title="list.title" class="article_title_one">{{list.title}}</router-link>
              </div>
            </li>
          </ul>
        </div>
      </el-col>
      <!-- 最近更新 -->
      <el-col :span="6" class="middle_box_right">
        <div class="box_top">
          <div class="box_title">
            <span>最</span>近更新
          </div>
          <!-- <router-link
            class="box_more"
            :to="{path:'/leftNavList',query: {id:65, name:'最近更新'}}"
            tag="a"
          >MORE</router-link> -->
        </div>
        <div class="box_bottom">
          <ul>
            <li v-for="(list,index) in zjgxData" :key="index">
              <div v-if="index<8" class="underLine_title">
                <router-link tag="a" :to="{path:'/article',query: {id:list.id, fId:7, sId:64, seo_title:list.seo_title}}" :title="list.title" class="article_title_one">{{list.title}}</router-link>
              </div>
            </li>
          </ul>
        </div>
      </el-col>
    </el-row>
    <el-row class="row_css xyfg">
      <!-- 校园风光 -->
      <el-col :span="24">
        <div class="big_box">
          <div class="box_top">
            <div class="box_title">
              <span>校</span>园风光
            </div>
            <router-link class="box_more" :to="{path:'/leftNavList',query: {fId:1, id:33, name:'今日滏中', secondName:'校园风光'}}" tag="a">MORE</router-link>
          </div>
          <div class="box_bottom xxx">
            <div v-for="(list,index) in xyfgData" :key="index" class="pic_box_c">
              <div v-if="index<5" class="pic_box">
                <router-link tag="a" :to="{path:'/article',query: {id:list.id, fId:1, sId:33, seo_title:list.seo_title}}" :title="list.title">
                  <img :src="list.thumb ? list.thumb : '../../static/img/noImg.png'" alt />
                  <p>{{list.title}}</p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <footer-elem></footer-elem>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import headerElem from "@/components/com/header";
import rotationElem from "@/components/com/rotation";
import footerElem from "@/components/com/footer";

var that;

export default {
  components: {
    "header-elem": headerElem,
    "rotation-elem": rotationElem,
    "footer-elem": footerElem
  },
  data() {
    return {
      url: url,
      xyxwData: [],
      ggtzData: [],
      zjgxData: [],
      xyfgData: [],
      dyzcData: [],
      jxzcData: [],
      djzcData: [],
    };
  },
  mounted() {
    that = this;
    that.init();
  },
  updated() {
    this.$nextTick(function () {
      var position = Number(sessionStorage.getItem("scrollHei"));
      $(document).scrollTop(position);
    });
  },
  beforeRouteLeave(to, from, next) {
    var position = $(document).scrollTop();
    sessionStorage.setItem("scrollHei", position);
    next();
  },
  methods: {
    init() {
      that.$nextTick(function () {
        that.articleFun(); //文章
      });
    },
    articleFun() {
      $.ajax({
        type: "get",
        url: url + "/archives",
        success: function (data) {
          if (data.code == "0") {
            var result = data.data;
            console.log(result);
            for (var i = 0; i < result.length; i++) {
              if (result[i].length > 0 && result[i][0].catid) {
                if (result[i][0].catid == "15") {
                  //校园新闻
                  that.xyxwData = result[i];
                } else if (result[i][0].catid == "16") {
                  //公告通知
                  that.ggtzData = result[i];
                } else if (result[i][0].catid == "65") {
                  //最近更新
                  that.zjgxData = result[i];
                } else if (result[i][0].catid == "33") {
                  //校园风光
                  that.xyfgData = result[i];
                } else if (result[i][0].catid == "6") {
                  //德育之窗
                  that.dyzcData = result[i];
                } else if (result[i][0].catid == "8") {
                  //教学之窗
                  that.jxzcData = result[i];
                } else if (result[i][0].catid == "7") {
                  //党建之窗
                  that.djzcData = result[i];
                }
              }
            }
          }
        },
        error(data) {
          // alert(data.msg);
        }
      });
    }
  },
  filters: {
    subStr(val, num) {
      if (val.length > num) {
        return val.substring(0, num) + "...";
      } else {
        return val;
      }
    },
    timesubStrYear(val) {
      return val.substring(0, 10);
    },
    timesubStr(val) {
      return val.substring(5, 10);
    }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/index.vue